/**
 * @file コンポーネント：モーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnSetFixedBody } from "~/src/functions/common";

// コンポーネントを返す
export const Modal = (props) => {
    /**
     * モーダル開閉状態管理
     */
    let isShow;
    let setIsShow;
    if (props.isShow !== undefined) {
        isShow = props.isShow;
        setIsShow = props.setIsShow;
    } else {
        [isShow, setIsShow] = useState(false);
    }
    useEffect(() => {
        let flag;
        if (props.isShow !== undefined) {
            flag = props.isShow;
        } else {
            flag = isShow;
        }
        fnSetFixedBody(flag);
    }, [props.isShow, isShow]);

    /**
     * 閉じるボタン有無
     */
    const [hasButtonClose, setHasButtonClose] = useState(true);
    useEffect(() => {
        setHasButtonClose(props.hasButtonClose);
    }, [props.hasButtonClose]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            hasButtonClose={hasButtonClose}
            isShow={isShow}
            setIsShow={setIsShow}
        />
    );
};
